'use client';

import { c as _c } from "react/compiler-runtime";
import { TextField, type SxProps } from '@mui/material';
import type React from 'react';
import { FormFieldFrame } from './formFieldFrame';
import type { FieldValidation } from './validation/fieldValidation';
export const FormTextField = t0 => {
  const $ = _c(30);
  const {
    size: t1,
    testId,
    title,
    helpText,
    alwaysShowHelp: t2,
    dataTestId,
    validation,
    placeholder,
    value,
    onChange,
    sx,
    disabled: t3,
    autoFocus: t4,
    multiline: t5,
    rows: t6,
    maxLength,
    type,
    inputProps,
    endAdornment,
    showValidationError: t7
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const alwaysShowHelp = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const autoFocus = t4 === undefined ? false : t4;
  const multiline = t5 === undefined ? false : t5;
  const rows = t6 === undefined ? 1 : t6;
  const showValidationError = t7 === undefined ? false : t7;
  let t8;
  if ($[0] !== dataTestId) {
    t8 = dataTestId ? {
      "data-testid": dataTestId
    } : {};
    $[0] = dataTestId;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  let t9;
  if ($[2] !== maxLength) {
    t9 = maxLength !== undefined ? {
      maxLength
    } : {};
    $[2] = maxLength;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== inputProps || $[5] !== t8 || $[6] !== t9) {
    t10 = {
      ...inputProps,
      ...t8,
      ...t9
    };
    $[4] = inputProps;
    $[5] = t8;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const htmlInputProps = t10;
  let t11;
  if ($[8] !== autoFocus || $[9] !== disabled || $[10] !== endAdornment || $[11] !== htmlInputProps || $[12] !== multiline || $[13] !== onChange || $[14] !== placeholder || $[15] !== rows || $[16] !== size || $[17] !== testId || $[18] !== type || $[19] !== value) {
    t11 = t12 => {
      const {
        hasError,
        errorAdornment,
        onBlur,
        inputId
      } = t12;
      return <TextField id={inputId} multiline={multiline} rows={rows} size={size} autoFocus={autoFocus} data-testid={testId} onBlur={onBlur} error={hasError} sx={{
        "& .MuiInputBase-root": {
          paddingRight: hasError ? "4px" : "24px"
        },
        ...(multiline && {
          "& .MuiOutlinedInput-input": {
            paddingLeft: "0px"
          }
        })
      }} slotProps={{
        htmlInput: htmlInputProps,
        input: {
          endAdornment: hasError ? errorAdornment : endAdornment
        }
      }} type={type} placeholder={placeholder} disabled={disabled} value={value} onChange={onChange} />;
    };
    $[8] = autoFocus;
    $[9] = disabled;
    $[10] = endAdornment;
    $[11] = htmlInputProps;
    $[12] = multiline;
    $[13] = onChange;
    $[14] = placeholder;
    $[15] = rows;
    $[16] = size;
    $[17] = testId;
    $[18] = type;
    $[19] = value;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== alwaysShowHelp || $[22] !== helpText || $[23] !== showValidationError || $[24] !== sx || $[25] !== t11 || $[26] !== title || $[27] !== validation || $[28] !== value) {
    t12 = <FormFieldFrame title={title} helpText={helpText} alwaysShowHelp={alwaysShowHelp} validation={validation} value={value} showValidationError={showValidationError} sx={sx}>{t11}</FormFieldFrame>;
    $[21] = alwaysShowHelp;
    $[22] = helpText;
    $[23] = showValidationError;
    $[24] = sx;
    $[25] = t11;
    $[26] = title;
    $[27] = validation;
    $[28] = value;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};